<wiz-hgroup #actionContainer width="100%" height="100%" verticalAlign="center" style="padding: 3px">
  <wiz-icon #btnConf *ngIf="showSettings" (click)="showConf()" >settings</wiz-icon >
    <wiz-hgroup width="100%">
      <wiz-label [wizLabel]="data.labelOrDefaultLabel" width="100%"></wiz-label>
    </wiz-hgroup>
  <wiz-icon *ngIf="isDate()" class="image-inactive">icon-calendar</wiz-icon>
  
  <wiz-icon #iconRemove *ngIf="isInContentList()" (click)="doDelete()">delete</wiz-icon>
</wiz-hgroup>
